import loadable from '@loadable/component';

// 懒加载组件
const StockupOrderQuery = loadable(() => import('./stockupOrderQuery/StockupOrderQuery'));
const StockupDeliveryQuery = loadable(() => import('./stockupDeliveryQuery/StockupDeliveryQuery'));
const StockupDeliveryModify = loadable(() => import('./stockupDeliveryQuery/stockupDeliveryModify/StockupDeliveryModify'));
const StockupReturnQuery = loadable(() => import('./stockupReturnQuery/StockupReturnQuery'));
const StockupDeliveryDetailQuery = loadable(() => import('./stockupDeliveryDetailQuery/StockupDeliveryDetailQuery'));
const StockupOrderDetailQuery = loadable(() => import('./stockupOrderDetailQuery/StockupOrderDetailQuery'));
const ItemMainBarcodeManagement = loadable(() => import('./itemMainBarcodeManagement/ItemMainBarcodeManagement'));
const ItemSetMangement = loadable(() => import('./itemSetMangement/ItemSetMangement'));
const ItemUsingDetailQuery = loadable(() => import('./itemUsingDetailQuery/ItemUsingDetailQuery'));
const OperationImplantationRequest = loadable(() => import('./operationImplantationRequest/OperationImplantationRequest'));
const OperationImplantationDetailModify = loadable(() => import('./operationImplantationRequest/operationImplantationDetailModify/OperationImplantationDetailModify'));
const ImplantableInvoiceQuery = loadable(() => import('./implantableInvoiceQuery/ImplantableInvoiceQuery'));
const ImplantableInvoiceDetailModify = loadable(() => import('./implantableInvoiceQuery/implantableInvoiceDetailModify/ImplantableInvoiceDetailModify'));
const AllStockUpItemValidDateQuery = loadable(() => import('./stockUpItemValidDateQuery/AllStockUpItemValidDateQuery'));
const BoxPreparation = loadable(() => import('./boxPreparation/BoxPreparation'));
const BoxDetailModify = loadable(() => import('./boxPreparation/boxDetailModify/BoxDetailModify'));
const StockUpInventoryQuery = loadable(() => import('./stockUpInventoryQuery/StockUpInventoryQuery'));

export default [
  {
    // 242502备货订单查询响应
    path: '/StockupOrderQuery',
    component: StockupOrderQuery
  },
  {
    // 242503备货发货单查询
    path: '/StockupDeliveryQuery',
    component: StockupDeliveryQuery
  },
  {
    // 242503备货发货单查询 -- 发货单明细编辑
    path: '/StockupDeliveryModify',
    component: StockupDeliveryModify
  },
  {
    // 225205备货退货单查询
    path: '/StockupReturnQuery',
    component: StockupReturnQuery
  },
  {
    // 242506备货发货单明细查询
    path: '/StockupDeliveryDetailQuery',
    component: StockupDeliveryDetailQuery
  },
  {
    // 242509备货订单明细查询
    path: '/StockupOrderDetailQuery',
    component: StockupOrderDetailQuery
  },
  {
    // 242504骨科包准备
    path: '/BoxPreparation',
    component: BoxPreparation
  },
  {
    // 242504骨科包准备 -- 骨科包明细编辑
    path: '/BoxDetailModify',
    component: BoxDetailModify
  },
  {
    // 704  备货耗材有效期查询页面
    path: '/AllStockUpItemValidDateQuery',
    component: AllStockUpItemValidDateQuery
  },
  {
    // 242401耗材条码维护
    path: '/ItemMainBarcodeManagement',
    component: ItemMainBarcodeManagement
  },
  {
    // 242402手术组套管理
    path: '/ItemSetMangement',
    component: ItemSetMangement
  },
  {
    // 242403耗材使用跟踪查询
    path: '/ItemUsingDetailQuery',
    component: ItemUsingDetailQuery
  },
  {
    // 242501备货库存查询
    path: '/StockUpInventoryQuery',
    component: StockUpInventoryQuery
  },
  {
    // 242510 植入性耗材手术申请单
    path: '/OperationImplantationRequest',
    component: OperationImplantationRequest
  },
  {
    // 242510 植入性耗材手术申请单 -- 明细编辑
    path: '/OperationImplantationDetailModify',
    component: OperationImplantationDetailModify
  },
  {
    // 242601 植入性发货单查询
    path: '/ImplantableInvoiceQuery',
    component: ImplantableInvoiceQuery
  },
  {
    // 242601 植入性发货单查询 -- 明细编辑
    path: '/ImplantableInvoiceDetailModify',
    component: ImplantableInvoiceDetailModify
  }
];
